module.exports = __webpack_public_path__ + "static/media/onza_thumb.a078af0e.webp";